export default __webpack_public_path__ + "static/media/appconstanciasnodeudor.53c5445c.png";